<!--
 * @Description: 客户账号详情-基本信息
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-03-07 15:05:43
 * @LastEditors: cxh
-->
<template>
  <a-form ref="formRef" name="advanced_search">
    <detail-card
      :columns="columns"
      v-for="(item, index) in detail"
      :key="index"
      :title="`${t('arkCode.codeDetailTitle')}${index + 1}`"
      :data="item"
    >
      <template #bodyCell="{ column, record, text }">
        <template v-if="column.dataIndex === 'subjectCount'">
          <a-button type="link" @click="linkToMainBody(record)"> {{ text || 0 }} </a-button>
        </template>
      </template>
    </detail-card>
    <dc-layout-empty type="nothing" v-if="!detail || !detail.length" />
  </a-form>
  <cos-footer-button :hideOk="true"> </cos-footer-button>
</template>
<script lang="ts">
import { onMounted, computed, ref } from 'vue'
import DetailCard from '@/components/DetailCard'
import { customerPhaseEnum, arkCodeStatusEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import { queryCosArkCodeDeatil } from '@/api/overseasSales/customerCenter'
import { useRoute, useRouter } from 'vue-router'
import { CustomerCode } from '@/typings/api/customerCenter'
import { useI18n } from 'vue-i18n'
export default { name: 'TabsCode' }
</script>
<script setup lang="ts">
const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const detail = ref([])

const fetch = () => {
  queryCosArkCodeDeatil({
    cosId: route.query.cosId
  }).then((res) => {
    detail.value = res.data
  })
}
onMounted(() => {
  fetch()
})
const columns = computed(() => [
  { title: t('arkCode.arkCode'), dataIndex: 'arkCode' },
  {
    title: t('arkCode.stage'),
    dataIndex: 'stage',
    node: 'cos-select',
    attrs: {
      options: customerPhaseEnum
    }
  },
  { title: t('arkCode.arkAccount'), dataIndex: 'arkAccount' },
  { title: t('arkCode.level'), dataIndex: 'level' },
  { title: t('arkCode.arkContact'), dataIndex: 'arkContactName' },
  { title: t('arkCode.amount'), dataIndex: 'amount' },
  { title: t('arkCode.arkContactMobile'), dataIndex: 'arkContactMobile' },
  { title: t('common.updateTime'), dataIndex: 'updateTime' },
  { title: t('arkCode.sellerName'), dataIndex: 'sellerName' },
  { title: t('common.createTime'), dataIndex: 'createTime' },
  {
    title: t('arkCode.arkStatus'),
    dataIndex: 'status',
    node: 'cos-select',
    attrs: {
      options: arkCodeStatusEnum
    }
  },
  {
    title: t('arkCode.subjectCount'),
    dataIndex: 'subjectCount'
  }
])
// 跳转到签约主体列表
const linkToMainBody = (row: CustomerCode) => {
  if (!row.subjectCount) {
    return
  }
  router.push({
    path: '/ofbu/mainBody',
    query: {
      customerCode: row.arkCode
    }
  })
}
</script>
